// extracted by mini-css-extract-plugin
module.exports = {"navItem":"navbar_navItem__3I-n5","active":"navbar_active__3uiWp"};